<template>
  <div class="recommendBox">
    <div class="logo">
      <img src="@/assets/img/h5/recommend/logo.png" alt />
    </div>
    <div class="inviceBox">
      <img class="title" src="@/assets/img/h5/recommend/title.png" alt />
      <ul>
        <li class="li1">
          <i></i>
          <div class="text">
            <p>数百门艺术教育课程</p>
            <p>数百名艺术家教育家</p>
          </div>
        </li>
        <li class="li2">
          <i></i>
          <div class="text">
            <p>全面科学合理的课程设计</p>
            <p>满足不同阶段的学习需求</p>
          </div>
        </li>
        <li class="li3">
          <i></i>
          <div class="text">
            <p>随时随地，在线学习</p>
            <p>专业专注，多样便捷</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="submit">
      <span @click="goto(false, '/h5/course/courseType', {})">去学习</span>
    </div>
    <div class="share" v-if="img">
      <img :src="img" alt="" />
      <span>来自{{ name }}的分享</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      img: "",
      name: "",
      userInfo: "",
    };
  },
  components: {},
  mounted() {
    this.img = this.$route.query.img ? this.$route.query.img : "";
    this.name = this.$route.query.name ? this.$route.query.name : "";
    if (localStorage.getItem("authorization")) {
      this.getuserInfo();
    }
    this.share();
  },
  methods: {
    getuserInfo() {
      this.$post("iart-api-crm/api/crm/customer/query").then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            this.userInfo = res.data;
          } else {
            this.util.toast({
              msg: res.message,
            });
          }
        }
      });
    },
    share() {
      var _this = this;
      var obj = {
        image: "http://picture.iartschool.com/20200211/676831665854611456.jpg",
        title: "我在爱艺术+已经学了N天了，邀请你一起来学习",
        introduction: "来爱艺术+ 跟着全世界艺术家学艺术！",
        url: _this.$store.state.state.shareUrl + "/h5/mine/recommend/recommend?",
      };
      if (this.userInfo) {
        obj.url +=
          "sharecode=" +
          this.userInfo.customercode +
          "&img=" +
          this.userInfo.headerimg +
          "&name=" +
          this.userInfo.nickname;
      }
      this.util.shareLink(obj);
    },
    goto(login, url, query) {
      if (login && !localStorage.getItem("authorization")) {
        this.util.wechatLogin();
      } else {
        this.$router.push({
          path: url,
          query: query,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.recommendBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url(../../../../assets/img/h5/recommend/bg.png) no-repeat;
  background-size: 100% 100%;
  padding: 0 40px;
  .logo {
    margin-top: 40px;
    text-align: center;
    img {
      width: 120px;
    }
  }
  .inviceBox {
    margin-top: 22px;
    background: #fff;
    border-radius: 10px;
    padding: 36px 25px;
    text-align: center;
    .title {
      width: 244px;
    }
    ul {
      margin-top: 25px;
      text-align: left;
      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        i {
          display: inline-block;
          width: 45px;
          height: 45px;
        }
        div {
          flex: 1;
          overflow: hidden;
          margin-left: 19px;
          p {
            font-size: 13px;
            line-height: 21px;
            color: #c07228;
          }
        }
      }
      li:not(:last-child) {
        margin-bottom: 19px;
      }
      .li1 {
        i {
          background: url(../../../../assets/img/h5/recommend/li1.png) no-repeat;
          background-size: 45px 45px;
        }
      }
      .li2 {
        i {
          background: url(../../../../assets/img/h5/recommend/li2.png) no-repeat;
          background-size: 45px 45px;
        }
      }
      .li3 {
        i {
          background: url(../../../../assets/img/h5/recommend/li3.png) no-repeat;
          background-size: 45px 45px;
        }
      }
    }
  }
  .submit {
    margin-top: 40px;
    span {
      display: inline-block;
      width: 100%;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      background: linear-gradient(125deg, #ff544e 0%, #fb3038 100%);
      border-radius: 48px;
      color: #fff8f8;
    }
  }
  .share {
    margin: 24px 0;
    text-align: center;
    img {
      display: inline-block;
      width: 20px;
      height: 20px;
      object-fit: cover;
      vertical-align: middle;
      border-radius: 50%;
    }
    span {
      color: #a66528;
      font-size: 13px;
      line-height: 20px;
      vertical-align: middle;
      margin-left: 8px;
    }
  }
}
</style>